module.exports = __webpack_public_path__ + "static/media/Picto_Cloud.990198dc.png";